import React from 'react';
import QuizGame from './QuizGame';
import './App.css';

function App() {
  return <QuizGame />;
}

export default App;
